import React from "react";
import { Component } from "react";

import { Container, Card } from "react-bootstrap";

class Footer extends Component {
    render() {
        return (
        <div>
            <Container>
    <Card>
        <Card.Body>
       
       
       <Card.Text>
      
        
       
<p>Concept and programming by <a target="_blank" rel="noreferrer" href="https://linktr.ee/marlonbarriososolano">Marlon Barrios Solano</a></p>
<p>Go to <a target="_blank" rel="noreferrer" href="https://www.sati-ai.app/">Sati-Ai main app </a></p>

            </Card.Text>
        </Card.Body>
    </Card>
</Container>
        </div>
        );
    }
    }
export default Footer;
